const API = process.env.REACT_APP_BACKEND_URL;

export const track = (type, label, path) => {
  try {
    fetch(`${API}/api/events`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        type,
        label: label || "",
        path: path || window.location.pathname,
      }),
      keepalive: true,
    }).catch(() => {});
  } catch (e) {
    /* no-op */
  }
};

export const trackCta = (label) => track("cta", label);
export const trackPage = (path) => track("page_view", "view", path);
